// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__1-oD1","log":"ModalInventoryLogs_log__1ik1j","date":"ModalInventoryLogs_date__1ePFE","userName":"ModalInventoryLogs_userName__205p5"};